// extracted by mini-css-extract-plugin
export default {"bottomNav":"bottomnav_bottomNav__bSgRQ","wrapper":"bottomnav_wrapper__o2Qqe","line":"bottomnav_line__lIs9F","selected":"bottomnav_selected__7pek2"};